export default [
  {
    name: 'dashboard',
    icon: 'dash',
    path: '/admin/overview'
  },
  // {
  //   name: 'Ordering Management',
  //   icon: 'ti-pencil-alt',
  //   path: '/ordering-management'
  // },
  {
    name: 'customers',
    icon: 'cust',
    path: '/customers'
  },
  // {
  //   name: 'Info Pages',
  //   icon: 'ti-info',
  //   path: '/info-pages'
  // },
  {
    name: 'orders',
    icon: 'order',
    path: '/orders',
    session: 'newOrders'
  },
  {
    name: 'catalog',
    icon: 'catalog',
    children: [{
      name: 'products',
      path: '/products'
    },
    {
      name: '',
      path: '/product/add'
    },
    {
      name: '',
      path: '/product/edit',
      isRoute: false
    },
    {
      name: 'categories',
      path: '/categories'
    },
    {
      name: '',
      path: '/category/add'
    },
    {
      name: 'productOptions',
      nameshort: 'PO',
      path: '/product-options'}]
  },
  {
    name: 'marketing',
    icon: 'marketing',
    children: [{
      path: '/marketing/campaigns',
      name: 'campaigns'
    },
    {
      path: '/marketing/offers',
      name: 'offersSlider',
      nameshort: 'OS'
    }]
  },
  {
    name: 'reports',
    icon: 'report',
    path: '/reports'
  },
  {
    icon: 'feedback',
    name: 'feedback',
    path: '/feedback',
    session: 'newFeedback'
  },
  {
    name: 'settings',
    icon: 'settings',
    path: '/settings'
    // children: [
    //   {
    //     name: 'General',
    //     path: '/settings'
    //   },
    //   {
    //     name: 'Users',
    //     path: '/users'
    //   }
    // ]
  }
]



// WEBPACK FOOTER //
// ./src/sidebarLinks.js